module.exports = __webpack_public_path__ + "static/img/SketchPngeca35eecdb147210a54d98a7847d69d3bc8b5291bca42985267a52ca1ac8d9a3.ca954572.png";